import React, { useState } from 'react';
import './ProductGroupListItem.css';

export default function ProductGroupListItem(props) {
    return <div className="ProductGroupListItem" onClick={props.click} data-name={ props.name } id={ 'ProductGroupListItemDiv-' + props.itemId }>
        <span className='ProductGroupListItemSpan' data-name={ props.name } id={ 'ProductGroupListItemSpan-' + props.itemId }>{ props.name }</span>
    </div>;
}

